import { render, staticRenderFns } from "./wish-card.vue?vue&type=template&id=9f91727a&scoped=true&"
import script from "./wish-card.vue?vue&type=script&lang=js&"
export * from "./wish-card.vue?vue&type=script&lang=js&"
import style0 from "./wish-card.vue?vue&type=style&index=0&id=9f91727a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f91727a",
  null
  
)

export default component.exports